import { useEffect, useState } from "react";
import base from "../middlewares/interceptors";
import { getUserSystemsUrl } from "../services/constants";

interface IUseFetchUserSystems {
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  userId: string | number | null | undefined;
}

const useFetchUserSystems = ({
  setIsLoading,
  userId,
}: IUseFetchUserSystems) => {
  const [userSystems, setUserSystems] = useState<number[]>([]);

  useEffect(() => {
    if (!userId) {
      setUserSystems([]);
      return;
    }

    const fetchUserSystems = async () => {
      if (setIsLoading) {
        setIsLoading(true);
      }

      try {
        const response = await base.get(
          `${getUserSystemsUrl}/${userId}/systems?include_inactive=false`
        );

        setUserSystems(response.data || []);
      } catch (err) {
        console.error("Error fetching user systems:", err);
        setUserSystems([]);
      } finally {
        if (setIsLoading) {
          setIsLoading(false);
        }
      }
    };

    fetchUserSystems();
  }, [userId, setIsLoading]);

  return [userSystems, setUserSystems] as const;
};

export default useFetchUserSystems;
